/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
/* eslint-disable node/no-unsupported-features */
import * as types from '../constants/ActionTypes';
import {Utils} from '../components/Utils';

Utils.init('actions');

export const changeTheme = (theme) => ({
    type: types.CHANGE_THEME,
    theme,
});

export const changeLocale = (locale) => ({
    type: types.CHANGE_LOCALE,
    locale,
});



// WEBPACK FOOTER //
// ./src/actions/index.js